import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'

function VenueSlider({ title = "Nearby venues" }) {
    const venues = useSelector(state => state.sport.allVenues)

    const VenueCard = ({ venue }) => (
        <NavLink
            to="/venue_screen"
            state={{ ...venue, isBooking: false }}
            className="bg-white rounded-lg overflow-hidden block"
        >
            <div className='p-2 bg-white border shadow-xl rounded-lg h-full'>
                <div className="relative rounded-t-lg overflow-hidden">
                    <img
                        src={venue?.profile_image[0]?.media_url}
                        alt={venue?.name || "Venue"}
                        className="w-full h-40 object-cover"
                    />
                </div>
                <div className="px-2 py-3 rounded-b-lg">
                    <div className="flex justify-between items-center">
                        <h2 className="text-lg font-semibold">{venue?.name}</h2>
                    </div>
                    <p className="text-gray-500 text-sm font-semibold truncate">
                        {venue?.address}
                    </p>
                    <span className="text-sm mt-1 text-gray-500 font-semibold">{venue?.contact_number}</span>
                    <p className="mt-2 text-sm text-gray-400 font-medium">
                        Price start from <span className="text-black">{venue?.lowest_sport_price}</span>
                    </p>
                </div>
            </div>
        </NavLink>
    )

    return (
        <>
            <p className='font-semibold text-xl capitalize mb-4'>{title}</p>

            {/* Mobile: Vertical List */}
            <div className='md:hidden flex flex-col gap-4'>
                {venues?.map((venue) => (
                    <VenueCard key={venue?.id} venue={venue} />
                ))}
            </div>

            {/* Desktop: Horizontal Scrollable List */}
            <div className='hidden md:block overflow-x-auto'>
                <div className='flex gap-6 pb-4'>
                    {venues?.map((venue) => (
                        <div key={venue?.id} className='flex-shrink-0' style={{ width: '320px' }}>
                            <VenueCard venue={venue} />
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default VenueSlider